import { InjectableClass } from '@fino/lib-injection';
import templateUrl from './confirmation.tpl.html';
import _ from 'lodash';

export class NeedsConfirmationService extends InjectableClass {
  constructor(uiModalDeclarationService) {
    'ngInject';
    super({ uiModalDeclarationService });
  }

  open(options = {}) {
    // Add default modal class
    _.defaults(options, {
      modalClass: 'confirmation-modal'
    });

    // Add default modal translation keys
    _.defaults(options.scope, {
      confirmTitle: 'component.needsConfirmation.modal.title',
      confirmBody: 'component.needsConfirmation.modal.body',
      confirmDismiss: 'component.needsConfirmation.modal.dismiss',
      confirmOk: 'component.needsConfirmation.modal.confirm',
      confirmSpecialAction: 'component.needsConfirmation.modal.specialAction'
    });

    return this.uiModalDeclarationService.openUrl({
      url: templateUrl,
      options
    });
  }
}
